module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ["auth", _vm.formId]
  }, [(_vm.$route.name === "register") ? _c('h1', {
    staticClass: "h1 group__title mw600 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("\n    " + _vm._s(_vm.f2fSelected ?
    "Submit your in-person appointment request" :
    _vm.queryData ?
    "Please register to continue" :
    "Let's book your appointment") + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name === "register" && _vm.id === "register") ? _c('p', {
    staticClass: "p group__desc mb0"
  }, [_vm._v("\n    Create an account to submit your request.\n  ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name === "register" && _vm.id === "register") ? _c('p', {
    staticClass: "p group__desc mb2 mt0"
  }, [_vm._v("\n    Already have an account?\n    "), _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.redirectToLogin
    }
  }, [_vm._v("Login")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb"
  }, [(_vm.auth.title) ? _c('h2', {
    staticClass: "h2 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.auth.title))]) : _vm._e(), _vm._v(" "), (_vm.auth.copy && _vm.showForm) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("\n      " + _vm._s(_vm.isRescheduling ?
    "You are rescheduling your appointment, we already have all you details, enter you initials below to confim your appointment" :
    _vm.auth.copy) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('module-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }],
    attrs: {
      "id": _vm.formId,
      "action": _vm.action,
      "success": _vm.onSuccess,
      "fail": _vm.onError
    }
  }, [_vm._l((_vm.auth.fields || {}), function(field, fieldId) {
    return _c('module-fieldset', _vm._b({
      key: fieldId,
      attrs: {
        "id": fieldId
      }
    }, 'module-fieldset', field, false))
  }), _vm._v(" "), _c('module-error', {
    attrs: {
      "id": _vm.formId
    }
  }), _vm._v(" "), _c('module-button', _vm._b({
    attrs: {
      "form": _vm.formId,
      "disabled": !(_vm.getForm(_vm.formId) || {}).valid,
      "button": "primary"
    }
  }, 'module-button', _vm.button, false)), _vm._v(" "), (_vm.id === 'verify') ? _c('module-button', {
    attrs: {
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sendVerification.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.verifyText) + "\n    ")]) : _vm._e()], 2), _vm._v(" "), (!_vm.showForm) ? [(_vm.id === "confirm") ? [_c('p', {
    staticClass: "medium"
  }, [_vm._v("You can now log in with your new password.")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "label": "Log in",
      "link": "login"
    }
  })] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showRescheduleLoader === true) ? _c('ui-module-loader', {
    key: "loader",
    attrs: {
      "messages": ['Please give us a moment to reschedule']
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444eb87f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Auth.vue
// module id = 475
// module chunks = 0